import axios from 'axios';

const adminApi = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL || '',
	headers: { 'Content-Type': 'application/json' }
});

adminApi.interceptors.request.use((config) => {
	const token = localStorage.getItem('adminAccessToken');
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

adminApi.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (error.response?.status === 401) {
			localStorage.removeItem('adminAccessToken');
			localStorage.removeItem('adminRefreshToken');
			window.location.href = '/admin-login';
		}
		return Promise.reject(error);
	}
);

export default adminApi;
